
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(76(8|94)|4(121|387|924)|5(264|272|657|878)|3(267|597|610)|1512|1752|6314|9379)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
